module.exports = "/_next/static/images/dorado-9148a3df7ff8f9d28565011b68ae9a32.png";